<template>
    <div class="loading-cards">
        <div v-for="index in count" :key="index" class="loading-card">
            <div class="loading-card__content"></div>
            <div class="loading-card__bar"></div>
            <div class="loading-card__bar"></div>
            <div class="loading-card__bar"></div>
        </div>
    </div>
</template>
<script setup>
defineProps({
    count: {
        type: Number,
        default: 6,
    },
});
</script>
<style lang="scss" scoped>
@use '@/scss/variables' as vars;

.loading-cards {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: row;
    grid-gap: 1em;
    max-height: 100vh;
    width: 100%;

    .loading-card {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        text-align: center;
        padding: 1em;
        flex: 0 0 calc(50% - 1em);
        background: rgba(194, 194, 194, 0.15);
        border-radius: vars.$borderRadius;

        .loading-card__content {
            width: 100%;
            height: 200px;
            margin-bottom: 1em;
            background: rgba(194, 194, 194, 0.25);
        }

        .loading-card__bar {
            width: 100%;
            height: 20px;
            margin-bottom: 1em;
            background: rgba(194, 194, 194, 0.25);
            animation: loading-animation 1.5s infinite;
        }
    }
}

@media screen and (max-width: vars.$mediumBreakpoint) {
    .loading-cards {
        .loading-card {
            flex: 0 0 100%;
        }
    }
}

@media screen and (min-width: vars.$mediumBreakpoint) and (max-width: vars.$largeBreakpoint) {
    .loading-cards {
        .loading-card {
            flex: 0 0 calc(50% - 1em);
        }
    }
}

@media screen and (min-width: vars.$largeBreakpoint) {
    .loading-cards {
        .loading-card {
            flex: 0 0 calc(33.333% - 1em);
        }
    }
}

@keyframes loading-animation {
    0% {
        opacity: 0.3;
    }

    50% {
        opacity: 1;
    }

    100% {
        opacity: 0.3;
    }
}
</style>
